/* Display amounts only. Never replace Shopify variant JSON or cart payload prices. */
window.SaleTagPricing = {
    percent(root) {
        const element = root?.jquery ? root[0] : root;
        const price = element?.matches('[data-sale-tag-percent]')
            ? element : element?.querySelector('[data-sale-tag-percent]');
        const percent = Number(price?.getAttribute('data-sale-tag-percent')) || 0;
        return Number.isInteger(percent) && percent > 0 && percent <= 100 ? percent : 0;
    },
    variant(variant, root) {
        if (!variant) return {};
        const percent = this.percent(root);
        if (!percent || variant.price <= 0) return { ...variant };
        return {
            ...variant,
            price: variant.price - Math.round(variant.price * percent / 100),
            compare_at_price: variant.price,
        };
    },
    sticky(root, variant, quantity) {
        const element = root?.jquery ? root[0] : root;
        if (!element || !variant) return;
        const display = this.variant(variant, element);
        const count = window.subtotal?.show ? Number(quantity) || 1 : 1;
        element.querySelectorAll('[data-sticky-add-to-cart] .sticky-price').forEach(price => {
            const hasCompare = display.compare_at_price > display.price;
            price.classList.toggle('has-compare-price', hasCompare);
            price.querySelectorAll('.money-compare-price').forEach(compare => compare.remove());
            if (hasCompare) {
                const compare = document.createElement('s');
                compare.className = 'money-compare-price';
                compare.dataset.comparePrice = display.compare_at_price;
                compare.innerHTML = Shopify.formatMoney(display.compare_at_price * count, window.money_format);
                price.prepend(compare);
            }
            const subtotal = price.querySelector('.money-subtotal');
            if (subtotal) subtotal.innerHTML = Shopify.formatMoney(display.price * count, window.money_format);
        });
    },
};
